import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import IconButton from '@mui/material/IconButton';
import AlertIcon from 'img/alert.svg';
import RedAlertIcon from 'img/alertRed.svg';
import CloseIcon from './icon.svg';

import useStyles from './styles';


const WarningBanner = ({ className, label, onClose, red, id, isDissmisable }) => {
    const [opened, setOpened] = useState(false);
    const storageKey = `${id}-banner-closed`;

    const classes = useStyles({ red });

    useEffect(() => {
        if (!id && !isDissmisable) {
            setOpened(true);
            return;
        }
        const item = localStorage.getItem(storageKey);
        if (!item) {
            setOpened(true);
        }
    }, [id]);

    if (!label) return null;
    if (!opened) return null;

    const closeBanner = () => {
        setOpened(false);
        localStorage.setItem(storageKey, true);
        if (onClose) onClose();
    };

    return (
        <div className={clsx(classes.wrapper, className, 'warning-banner')}>
            <img src={red ? RedAlertIcon : AlertIcon} alt="!" />
            <div className={clsx(classes.warningText, 'u-dsp--f u-ai--center')}>
                {label}
            </div>
            {
                isDissmisable && (
                    <IconButton onClick={closeBanner} className={classes.closeIcon} size="large">
                        <img src={CloseIcon} alt="close" />
                    </IconButton>
                )
            }
        </div>
    );
};

export default WarningBanner;
